<template>
  <!-- .ld live-date -->
  <div
    :class="isLive ? 'ly' : ''"
    class="ld"
  >
    <!-- 活动简介 -->
    <div
      class="sche_intro"
      v-if="introduction&&introduction.length"
    >
      <van-collapse v-model="activeNames">
        <van-collapse-item
          :value="activeNames[0]=='1'?'close':'open'"
          name="1"
          title="introduction"
        >
          <div
            class="comm_text"
            v-if="introduction.length"
          >
            <div
              :key="index"
              v-for="(item,index) in introduction"
            >
              <!-- 文本 -->
              <p
                :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}"
                class="int-text"
                v-html="$service.replaceSpeace(item.text.content)"
                v-if="item.text"
              ></p>
              <!-- 图片 -->
              <div
                :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}"
                class="int-img"
                v-if="item.picture && item.picture.type == 1"
              >
                <div
                  :key="idx"
                  :style="{'margin-bottom':item.picture.spacing+'px'}"
                  v-for="(itm,idx) in item.picture.list"
                >
                  <img
                    :large="itm.url"
                    :preview-text="actData.title"
                    :src="itm.url"
                    preview="1"
                    style="width:100%;display: block"
                    v-load="'oIntro'"
                  />
                </div>
              </div>
              <div
                class="comm_banner"
                style
                v-if="item.picture && item.picture.type == 2"
              >
                <van-swipe
                  :autoplay="4000"
                  class="my-swipe"
                  v-if="actData"
                >
                  <van-swipe-item
                    :key="'pic' + index"
                    v-for="(item, index) in item.picture.list"
                  >
                    <img
                      :large="item.url"
                      :preview-text="actData.title"
                      :src="item.url"
                      preview="1"
                      style="width: 100%;height: 100%;display: block;"
                      v-load="'oIntro'"
                    />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <!-- 视频 -->
              <div
                class="int-video"
                style="position:relative;"
                v-if="item.video && item.video.link"
              >
                <videoPlayer
                  :cover="item.video.cover"
                  :height="'3.85'"
                  :time="item.video.time"
                  :url="item.video.link"
                ></videoPlayer>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <template v-if="actData.showSchedule">
      <div
        class="sche_content"
        v-if="DateList.length>0"
      >
        <div
          :style="'bottom: 20px'"
          class="steps_bar"
        ></div>
        <template v-for="(item,index) in DateList">
          <!-- <div
            :key="'sche-1-' + index"
            class="sche_item"
          >
            <div class="step">{{index+1}}</div>
            <div
              class="info"
              style="width: 80%"
            >
              <p class="date">{{item[0].startAt | moment('YYYY/MM/DD')}}</p>
            </div>
          </div> -->
          <div
            :key="'sche-child-' + index + idx"
            class="sche_item2"
            v-for="(it, idx) in item"
          >
            <div class="step"></div>
            <div
              class="info"
              style="width: 80%"
            >
              <p class="date">
                {{it.startAt | moment('YYYY/MM/DD HH:mm')}} ~ {{it.endAt | moment('YYYY/MM/DD HH:mm')}}
                <span
                  class="schedule_tag red"
                  id="waa"
                  v-if="it.state==1"
                >Ing</span> 
                <span
                  class="schedule_tag"
                  v-if="it.state==2"
                >Finished</span>
              </p>
              <p
                :class="it.state==1 ? 'ing' : ''"
                class="sche_type"
              >
                {{it.title || it.content}}
                <!-- <span>{{item.speaker}}</span> -->
              </p>
            </div>
          </div>
        </template>
      </div>
      <div
        class="u-empty"
        v-else
      >No data！</div>
    </template>
    <div style="height: 1rem"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import gql from 'graphql-tag'
import videoPlayer from "../../product-detail/videoPlayer";
export default {
  name: "live-date",
  props: ['introduction', 'actData', 'isLive'],
  data () {
    return {
      show: false, //是否显示助力排行榜
      stepsBarH: 0, //步骤条高度
      startData: [],
      scroll: null,
      starttimeList: [],
      endtimeList: [],
      status: 0,
      DateList: [],
      activeNames: ['1'],
      exhibitionSchedules: {},
      activitySchedules: {},
    };
  },
  components: {
    videoPlayer
  },
  computed: {
    ...mapGetters({
      exhibitionId: 'getExhibitionId',
    }),
    query () {
      return this.$router.history.current.query;
    },
    SchedulesGql () { // 查询活动日程
      return gql`query activitySchedules($activityId: Guid!){
            activitySchedules(activityId: $activityId){
                activityId
                content
                contentEn
                createAt
                endTime
                date
                id
                isDeleted
                startTime
                title
                updateAt
            }
          }`
    },
    ExSchedulesGql () { // 查询展会日程
      return gql`query exhibitionSchedules($exhibitionId: Guid!){
            exhibitionSchedules(exhibitionId: $exhibitionId){
                createAt
                date
                endTime
                id
                isDeleted
                startTime
                theme
                updateAt
            }
          }`
    }
  },
  watch: {
    actData (val, oldval) {
      if (!this.actData.showSchedule) {
        return
      }
      this.init();
    }
  },
  created () {
    // console.log(,'活动详情')
    if (!this.actData.showSchedule) {
      return
    }
    if (this.actData.exhibitorId || !this.actData.isExhibitionActivity) {  // 展商日程 
      this.getscheList();
    } else { //展会日程
      this.getExscheList();
    }
  },
  methods: {
    init () {
      if (this.actData.exhibitorId || !this.actData.isExhibitionActivity) {  // 展商日程 
        this.getscheList();
      } else { //展会日程
        this.getExscheList();
      }
    },
    getscheList () {
      this.$apollo.addSmartQuery('activitySchedules', {
        query: this.SchedulesGql,
        variables: {
          activityId: this.query.actId
        },
        fetchPolicy: 'no-cache',  // 清除缓存的数据，重新获取服务器数据
        result (res) {
          console.log(res, '1111111')
          if (res.data.activitySchedules) {
            let List = JSON.parse(JSON.stringify(res.data.activitySchedules));
            var obj = {}, newArr = [];
            List.sort(function (a, b) {
              return Date.parse(b.startTime.replace(/-/g, "/")) - Date.parse(a.startTime.replace(/-/g, "/"));
            });
            List.forEach((item, suffix) => {
              // let startAt = item.date.slice(0, 11) + item.startTime.slice(11, 19);
              item.startAt = item.startTime.replace(/-/g, "/");
              // let endAt = item.date.slice(0, 11) + item.endTime.slice(11, 19);
              item.endAt = item.endTime.replace(/-/g, "/");
              // item.startAt = item.startAt.replace(/\-/g, "/");
              // item.endAt = item.endAt.replace(/\-/g, "/");
              item.state = this.compareDate(item.startAt, item.endAt)
              if (!obj[item.startAt.substring(0, 11)]) {
                var arr = [];
                arr.push(item);
                newArr.push(arr);
                obj[item.startAt.substring(0, 11)] = item;
              } else {
                newArr.forEach((value, index) => {
                  if (value[0].startAt.substring(0, 11) == item.startAt.substring(0, 11)) {
                    value.push(item)
                  }
                })
              }
            })
            newArr.forEach((e => {
              e.sort((a, b) => {
                return Date.parse(a.startTime.replace(/-/g, "/")) - Date.parse(b.startTime.replace(/-/g, "/"));
              })
            }))
            this.DateList = newArr.reverse();
            console.log(this.DateList, 'this.DateList')
          }
        },// 错误处理
        error (error) {
          console.error(error, 'error错误处理')
        }
      })
    },
    getExscheList () {
      this.$apollo.addSmartQuery('exhibitionSchedules', {
        query: this.ExSchedulesGql,
        variables: {
          exhibitionId: this.exhibitionId
        },
        fetchPolicy: 'no-cache',  // 清除缓存的数据，重新获取服务器数据
        result (res) {
          if (res.data.exhibitionSchedules) {
            let List = JSON.parse(JSON.stringify(res.data.exhibitionSchedules));
            var obj = {}, newArr = [];
            List.sort(function (a, b) {
              return Date.parse(b.startTime.replace(/-/g, "/")) - Date.parse(a.startTime.replace(/-/g, "/"));
            });
            List.forEach((item, suffix) => {
              // let startAt = item.date.slice(0, 11) + item.startTime.slice(11, 19);
              item.startAt = item.startTime.replace(/\-/g, "/");
              // let endAt = item.date.slice(0, 11) + item.endTime.slice(11, 19);
              item.endAt = item.endTime.replace(/\-/g, "/");
              item.title = item.theme;
              item.state = this.compareDate(item.startAt, item.endAt)
              if (!obj[item.startAt.substring(0, 11)]) {
                var arr = [];
                arr.push(item);
                newArr.push(arr);
                obj[item.startAt.substring(0, 11)] = item;
              } else {
                newArr.forEach((value, index) => {
                  if (value[0].startAt.substring(0, 11) == item.startAt.substring(0, 11)) {
                    value.push(item)
                  }
                })
              }
            })
            newArr.forEach((e => {
              e.sort((a, b) => {
                return Date.parse(a.startTime.replace(/-/g, "/")) - Date.parse(b.startTime.replace(/-/g, "/"));
              })
            }))
            this.DateList = newArr.reverse();
            console.log(this.DateList, 'this.DateList')
          }
        },// 错误处理
        error (error) {
          console.error(error, 'error错误处理')
        }
      })
    },
    // 比较时间
    compareDate (statedate, enddate) {
      const stateTime = new Date(statedate).getTime();
      const Time = new Date().getTime();
      const endTime = new Date(enddate).getTime();
      if (stateTime < Time && Time < endTime) {
        return 1; //进行中
      } else if (endTime < Time) {
        return 2; //已结束
      } else {
        return 3; //未开始
      }
    },
  },
};
</script>

<style scoped lang="scss">
.ly {
  overflow-y: auto;
}
.schedule_tag {
  font-size: 0.2rem;
  vertical-align: middle;
  padding: 0 0.08rem;
  border-radius: 0.03rem;
  display: inline-block;
  background: #e6e6e6;
  color: #666;
  margin-left: 0.2rem;
  transform: translateY(-0.02rem);
  &.red {
    background: #ff4550;
    color: #fff;
  }
}
.sche_intro {
  border-bottom: 10px solid #f5f5f5;
  &_title {
    height: 0.84rem;
    padding: 0 0.3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333;
    .open {
      color: #666;
      .icon {
        color: #999;
      }
    }
  }
}
.sche_content {
  padding: 0rem 0.3rem;
  position: relative;
  .steps_bar {
    width: 0.04rem;
    position: absolute;
    left: 0.53rem;
    z-index: 0;
    top: 0;
    bottom: 0;
    background: #ff4550;
  }
  .sche_item {
    display: flex;
    margin-top: 0.48rem;
    position: relative;
    z-index: 1;
    &.end {
      .sche_type {
        color: #999;
      }
    }
    .step {
      margin-right: 0.27rem;
      width: 0.52rem;
      height: 0.52rem;
      line-height: 0.54rem;
      border-radius: 50%;
      background: linear-gradient(to left, #ff416c, #ff4b2b);
      color: #fff;
      font-size: 0.26rem;
      text-align: center;
    }
    .info {
      font-size: 15px;
      color: #ff5c00;
      display: flex;
      align-items: center;
    }
    .sche_user {
      display: flex;
      color: #333;
      img {
        width: 0.36rem;
        height: 0.36rem;
        object-fit: cover;
        display: block;
        margin-right: 0.1rem;
        border-radius: 50%;
      }
    }
  }
  .sche_item2 {
    display: flex;
    margin-top: 0.48rem;
    position: relative;
    z-index: 1;
    &.end {
      .sche_type {
        color: #999;
      }
    }
    .step {
      margin: 0 0.39rem 0 0.14rem;
      width: 0.24rem;
      height: 0.24rem;
      line-height: 0.54rem;
      border-radius: 50%;
      background: linear-gradient(to left, #ff416c, #ff4b2b);
      color: #fff;
      font-size: 0.26rem;
      text-align: center;
    }
    .date {
      line-height: 0.28rem;
      height: 0.28rem;
      font-size: 0.24rem;
      margin-bottom: 0.12rem;
      font-size: 0.24rem;
      color: #999;
    }
    .sche_type {
      line-height: 1.5em;
      margin-bottom: 0.14rem;
      font-size: 0.24rem;
      color: #999;
      span {
        color: #666;
        margin-left: 0.3rem;
      }
    }
    .ing {
      color: #333;
    }
    .msg {
      display: flex;
      img {
        width: 0.84rem;
        height: 0.84rem;
        object-fit: cover;
        display: block;
        margin-right: 0.12rem;
        border-radius: 0.03rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .sche_user {
      display: flex;
      color: #333;
      img {
        width: 0.36rem;
        height: 0.36rem;
        object-fit: cover;
        display: block;
        margin-right: 0.1rem;
        border-radius: 50%;
      }
    }
  }
}
.comm_text {
  background: #fff;
  color: #333;
  // padding: 0.35rem 0;
  // margin-bottom: 0.2rem;
  > span {
    line-height: 1;
    padding: 0 0 0.2rem 0.3rem;
    font-size: 0.32rem;
    display: inline-block;
  }
  p {
    line-height: 0.48rem;
    font-size: 0.28rem;
  }
  img {
    display: block;
  }
  .int-text {
    padding: 0.3rem 0;
  }
}
</style>
